<template>
  <el-dialog
    custom-class="qrcode-dialog"
    :visible.sync="qrcodeVisible"
    center
    :close-on-press-escape="false"
    :title="(payInfo.payType === 'alipay' ? '支付宝' : '微信') + '扫描支付'"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="content-wrap">
      <p class="price">
        支付
        <span>{{ payInfo.price / 100 }}</span>
        元
      </p>
      <img
        class="qrcode"
        :src="payInfo.qrcodeImg"
        width="160px"
        alt="支付二维码"
      />
      <div class="tips">
        <img src="@/assets/img/payment/scan-icon.png" alt="" />
        <p>
          打开手机{{ payInfo.payType === "alipay" ? "支付宝" : "微信" }}
          <br />
          扫一扫继续付款
        </p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data: function () {
    return {
      qrcodeVisible: false,
      payInfo: {
        payType: "alipay",
        qrcodeImg: "",
        price: "",
      },
    };
  },
  methods: {
    showDialog(obj) {
      this.payInfo = { ...obj };
      this.qrcodeVisible = true;
    },
    handleClose() {
      this.qrcodeVisible = false;
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .qrcode-dialog {
  width: 450px;
}
.qrcode-dialog {
  .content-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    .price {
      font-size: 14px;
      margin-bottom: 8px;
      color: var(--text-primary, #0d1400);
      span {
        color: $chiral-price-color;
      }
    }
    .tips {
      display: flex;
      font-size: 12px;
      align-items: center;
      margin-top: 15px;
      color: var(--text-secondary, #515350);
      img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
    }
  }
}
@media (max-width: 767px) {
  ::v-deep .qrcode-dialog {
    width: 90%;
  }
  .qrcode-dialog {
    .content-wrap {
      .price {
        font-size: 0.35rem;
        margin-bottom: 0.21rem;
      }
      .tips {
        display: flex;
        font-size: 0.32rem;
        align-items: center;
        margin-top: 0.4rem;
        img {
          width: 0.8rem;
          height: 0.8rem;
          margin-right: 0.27rem;
        }
      }
    }
  }
}
</style>
